import {startCase} from "lodash";
import * as React from 'react';
import {useState} from "react";
import {Button, ListContent, ListItem} from "semantic-ui-react";
import {Playshot} from "../../model/Playshot";
import {nodeLabel, removeDefaultService} from "../../service/playshot/default-service";
import {PlayshotChanged} from "../../service/playshot/diff/PlayshotChanged";
import CellIcon from "../CellIcon";
import PlayshotDiffEditor from "./PlayshotDiffEditor";

interface OwnProps {
  change: PlayshotChanged;
  playshot: Playshot;
  id: string;
}

type PlayshotChangedDiffProps = OwnProps;

const PlayshotChangedDiff = (props: PlayshotChangedDiffProps) => {
  const [showDiff, setShowDiff] = useState(false);

  return <ListItem>
    <CellIcon cellType={props.change.nodeType} size="normal" />
    <ListContent>
      {startCase(props.change.type)}: {nodeLabel(props.change.name)}
        &nbsp;&nbsp;<Button basic={true} className="noborder nopadding" size="small" icon={`chevron ${showDiff ? 'down' : 'up'}`} compact={true} onClick={() => setShowDiff(!showDiff)} />
      {showDiff && <div style={{padding: "10px 0"}}>
        <PlayshotDiffEditor change={props.change} containerId={`diff-container-${props.id}`} />
      </div>}
    </ListContent>
  </ListItem>
};

export default PlayshotChangedDiff;
